import { render, staticRenderFns } from "./bankuaitab.vue?vue&type=template&id=6bbcf3ac&scoped=true&"
import script from "./bankuaitab.vue?vue&type=script&lang=js&"
export * from "./bankuaitab.vue?vue&type=script&lang=js&"
import style0 from "./bankuaitab.vue?vue&type=style&index=0&id=6bbcf3ac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbcf3ac",
  null
  
)

export default component.exports